import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { SUPPORT_EMAIL } from "@/lib/company";
import { useAuth } from "@/lib/auth";
import { CheckCircle2, XCircle, Loader2, Crown } from "lucide-react";

export default function SubscriptionSuccess() {
    const [params] = useSearchParams();
    const { refresh } = useAuth();
    const session_id = params.get("session_id");
    const [status, setStatus] = useState("polling");
    const [info, setInfo] = useState(null);

    useEffect(() => {
        if (!session_id) { setStatus("error"); return; }
        let attempts = 0;
        const maxAttempts = 8;
        const poll = async () => {
            attempts += 1;
            try {
                const { data } = await api.get(`/subscription/status/${session_id}`);
                setInfo(data);
                if (data.payment_status === "paid" || data.payment_status === "no_payment_required") {
                    setStatus("paid");
                    refresh();
                    return;
                }
                if (data.status === "expired") { setStatus("expired"); return; }
                if (attempts >= maxAttempts) { setStatus("timeout"); return; }
                setTimeout(poll, 2000);
            } catch (e) {
                if (attempts >= maxAttempts) setStatus("error");
                else setTimeout(poll, 2000);
            }
        };
        poll();
    }, [session_id, refresh]);

    return (
        <div data-testid="subscription-success-page" className="pt-32 pb-24 max-w-2xl mx-auto px-6 text-center">
            {status === "polling" && (
                <>
                    <Loader2 size={36} className="text-gold mx-auto animate-spin mb-6" />
                    <h1 className="font-serif text-3xl text-ink-50">Verifica pagamento in corso...</h1>
                    <p className="text-ink-400 mt-4">Un attimo, stiamo confermando con Stripe.</p>
                </>
            )}
            {status === "paid" && (
                <>
                    <CheckCircle2 size={48} className="text-gold mx-auto mb-6" />
                    <span className="label-eyebrow">Pagamento confermato</span>
                    <h1 className="font-serif text-4xl text-ink-50 mt-3 flex items-center justify-center gap-2"><Crown size={26} className="text-gold" /> Benvenuto a bordo</h1>
                    <p className="text-ink-400 mt-6">Il tuo abbonamento <strong className="text-ink-50">{info?.plan_id}</strong> è ora attivo. Puoi pubblicare annunci e sbloccare i contatti.</p>
                    <div className="flex justify-center gap-3 mt-10">
                        <Link to="/dashboard" data-testid="success-go-dashboard" className="px-8 py-3 bg-gold text-black text-sm font-medium hover:bg-gold-soft transition-colors">Vai alla dashboard</Link>
                        <Link to="/pubblica" className="px-8 py-3 border border-white/20 text-ink-50 text-sm hover:border-gold transition-colors">Pubblica un annuncio</Link>
                    </div>
                </>
            )}
            {(status === "error" || status === "expired" || status === "timeout") && (
                <>
                    <XCircle size={36} className="text-red-400 mx-auto mb-6" />
                    <h1 className="font-serif text-3xl text-ink-50">Verifica non riuscita</h1>
                    <p className="text-ink-400 mt-4">Riprova o contatta il supporto: <a href={`mailto:${SUPPORT_EMAIL}`} className="text-gold hover:underline">{SUPPORT_EMAIL}</a>.</p>
                    <Link to="/prezzi" className="mt-8 inline-block px-6 py-3 border border-white/20 text-ink-50">Torna ai piani</Link>
                </>
            )}
        </div>
    );
}
